(function () {
  function appendCurrencyCode() {
    var code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!code) return;

    var priceEls = document.querySelectorAll(
      '.swym-storefront-layout-grid-item-final-price, .swym-storefront-layout-grid-item-compare-price'
    );
    for (var i = 0; i < priceEls.length; i++) {
      var el = priceEls[i];
      if (el.textContent.indexOf(code) === -1) {
        el.textContent += ' ' + code;
      }
    }
  }

  var MAX_ATTEMPTS = 20;

  function watchDrawer(attempt) {
    var drawer = document.getElementById('swym-storefront-layout-container');
    if (!drawer) {
      if (attempt < MAX_ATTEMPTS) setTimeout(function () { watchDrawer(attempt + 1); }, 500);
      return;
    }
    appendCurrencyCode();
    new MutationObserver(appendCurrencyCode).observe(drawer, { childList: true, subtree: true });
  }

  watchDrawer(0);
})();
